export default "__VITE_ASSET__94b0bac0__"